export default __webpack_public_path__ + "static/media/React-App.1227a2c0.png";